module startex {

    export class ClickExtend {


    }

}
